import axios from 'axios';

const remove = async (teamId: string) => {
  const { data } = await axios.delete(`/team/${teamId}`);
  return data;
};

export default remove;
